import Button from 'atoms/Button/Button';
import Stack from 'atoms/Layout/Stack/Stack';
import HeadingAndSupportingTextWithActions from 'molecules/HeadingAndSupportingText/HeadingAndSupportingTextWithActions';
import React from 'react';

interface ThankYouMessageProps {
  onButtonClick: () => void;
}

const ThankYouMessage = ({ onButtonClick }: ThankYouMessageProps): JSX.Element => (
  <Stack>
    <HeadingAndSupportingTextWithActions
      direction='column'
      gap='spacing-xl'
      heading={{
        text: 'You got it',
        type: 'heading',
        size: 'lg',
        textAlign: 'center',
      }}
      supportingText={{
        text: 'The first tips are on their way to your inbox',
        type: 'paragraph',
        size: 'md',
        textAlign: 'center',
      }}
      actions={
        <Stack
          marginTop='spacing-xl'
          justify='center'
          align='center'
          maxWidth='width-fit-content'
          margin={['spacing-none', 'spacing-auto']}
        >
          <Button
            variant='primary'
            size='md'
            onClick={onButtonClick}
          >
            Return to Mighty Pro
          </Button>
        </Stack>
      }
    />
  </Stack>
);

export default ThankYouMessage;
